import { getOptionDefaultValue } from '../../components/DownloadDialog/config';
import normalizeFormatMimeType from '../normalizeFormatMimeType';

/**
 * @param {object} [dialogParams] - AssetsCopyDialog onConfirm payload (may include presetId)
 * @returns {object|null}
 */
export default function buildCopyConvertingParams(dialogParams) {
  if (!dialogParams || dialogParams.mimeType === 'original') {
    return null;
  }
  const {
    mimeType: mimeTypeRaw,
    quality,
    resizing,
    presetId,
    width,
    isArchive,
    organizeByCollections,
    withoutWatermark,
    resolution,
    usePdfProxy,
  } = dialogParams;

  const mimeType = normalizeFormatMimeType(mimeTypeRaw);

  const config = {
    mimeType,
    organizeByCollections,
    isArchive,
    withoutWatermark,
    resolution,
    usePdfProxy,
    _id: presetId,
  };

  config.quality = quality;
  config.resizing = resizing;

  if (resizing !== getOptionDefaultValue('resizing')) {
    config.width = Number(width);
  }

  return config;
}
